import { $getRoot, LexicalEditor } from 'lexical';

export function clearEditor(editor: LexicalEditor) {
  editor.update(() => {
    $getRoot().clear();
  });
}
